import { type ZonedDateTime, CalendarDate } from '@internationalized/date';
import {
  CreatePurchaseLoadLineItemInput,
  CurrencyCode,
  MoneyInput,
  PurchaseLoadInput,
  WeightDisplayUnit,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadCreateAtom = createMutationAtomFactory(
  'trade.purchaseLoadCreate',
  (params: {
    receivedDate: ZonedDateTime;
    facilityId: string;
    currencyCode: CurrencyCode;
    description?: string | null;
    purchaseOrderId?: string | null;
    supplierAccountId?: string | null;
    containerTypeId?: string | null;
    carrierAccountId?: string | null;
    freightCost?: MoneyInput | null;
    freightTerms?: string | null;
    bolNumber?: string | null;
    heavyWeight?: WeightInput | null;
    lightWeight?: WeightInput | null;
    weightDisplayUnit: WeightDisplayUnit;
    shippingCarrierName?: string | null;
    scac?: string | null;
    driverName?: string | null;
    truckNumber?: string | null;
    trailerNumber?: string | null;
    containerNumber?: string | null;
    sealNumber?: string | null;
    internalNotes?: string | null;
    externalNotes?: string | null;
    receivingTicketNumber?: string | null;
    receivedTicketIssueDate?: CalendarDate | null;
    lineItems?: CreatePurchaseLoadLineItemInput[];
  }) => {
    const input: PurchaseLoadInput = {
      receivedDate: params.receivedDate.toAbsoluteString(),
      facilityId: params.facilityId,
      currencyCode: params.currencyCode,
      weightDisplayUnit: params.weightDisplayUnit,
    };
    if (params.description) input.description = params.description;
    if (params.purchaseOrderId) input.purchaseOrderId = params.purchaseOrderId;
    if (params.supplierAccountId)
      input.supplierAccountId = params.supplierAccountId;
    if (params.containerTypeId) input.containerTypeId = params.containerTypeId;
    if (params.carrierAccountId)
      input.carrierAccountId = params.carrierAccountId;
    if (params.freightCost) input.freightCost = params.freightCost;
    if (params.freightTerms) input.freightTerms = params.freightTerms;
    if (params.bolNumber) input.bolNumber = params.bolNumber;
    if (params.heavyWeight) input.heavyWeight = params.heavyWeight;
    if (params.lightWeight) input.lightWeight = params.lightWeight;
    if (params.shippingCarrierName)
      input.shippingCarrierName = params.shippingCarrierName;
    if (params.scac) input.scac = params.scac;
    if (params.driverName) input.driverName = params.driverName;
    if (params.truckNumber) input.truckNumber = params.truckNumber;
    if (params.trailerNumber) input.trailerNumber = params.trailerNumber;
    if (params.containerNumber) input.containerNumber = params.containerNumber;
    if (params.sealNumber) input.sealNumber = params.sealNumber;
    if (params.internalNotes) input.internalNotes = params.internalNotes;
    if (params.externalNotes) input.externalNotes = params.externalNotes;
    if (params.receivingTicketNumber)
      input.receivingTicketNumber = params.receivingTicketNumber;
    if (params.receivedTicketIssueDate)
      input.receivedTicketIssueDate = params.receivedTicketIssueDate.toString();
    if (params.lineItems) input.lineItems = params.lineItems;

    return {
      tradePurchaseLoadCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
